import superagent from '@ott/superagent';
import { createAsyncThunk } from '@reduxjs/toolkit';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import { Payload, RequestResponse } from './types';
import { RequestError } from '../../types';
import prepareQuery from '../../helpers/prepareQuery';

export const getINN = createAsyncThunk<RequestResponse, Payload, { rejectValue: RequestError }>(
  'virtualCard/inn/fetch',
  async (payload, { rejectWithValue }) => {
    try {
      const { firstName, middleName, lastName, birthDate, documentNumber } = payload;
      const url = '/_virtual_cards/external/inn';
      const query = prepareQuery({
        firstName,
        middleName,
        lastName,
        birthDate: format(parse(birthDate, 'ddMMyyyy', new Date()), 'yyyy-MM-dd'),
        documentSeries: documentNumber.slice(0, 4),
        documentNumber: documentNumber.slice(4),
      });

      const {
        body: { error, result },
      } = await superagent.get(url).query(query);

      if (error) {
        throw error;
      }

      return result as RequestResponse;
    } catch (error: any) {
      return rejectWithValue(error.response.body as RequestError);
    }
  }
);
